module.exports = __webpack_public_path__ + "img/product_70.b57d929.webp";